import { makeObservable } from 'mobx'

import { ServerTableData } from './serverTableData'

import { MyProductColumnId } from '../types/myProductColumnIds'

import { MyProductModel } from '../server/mpsklad_core/Models/MyProductModel'
import { MyProductsTableFilterColumn } from '../server/mpsklad_core/Models/MyProductsTableFilterColumn'
import { MyProductsTableOrderColumn } from '../server/mpsklad_core/Models/MyProductsTableOrderColumn'

export class MyProductsTableData
  extends ServerTableData<MyProductModel, MyProductColumnId,
    typeof MyProductsTableFilterColumn, typeof MyProductsTableOrderColumn> {
  constructor() {
    super('myProducts', MyProductsTableFilterColumn, MyProductsTableOrderColumn)

    makeObservable(this)
  }
}